import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS } from '../types/auth';
import { SET_CURRENCY_INFO } from '../types/currencyInfo';

export type CurrencyInfoType = {
    locale: string;
    currencyCode: string;
    currencySymbol: string;
};

const initState: Partial<CurrencyInfoType> = {
    locale: "en-IN",
    currencyCode: "INR",
    currencySymbol: "20B9"
};
export default function currencyInfoReducer(state = initState, action: AnyAction): Partial<CurrencyInfoType> {
    switch (action.type) {
        case SET_CURRENCY_INFO: {
            return {
                ...state,
                locale: action.locale,
                currencyCode: action.currencyCode,
                currencySymbol: action.currencySymbol
            };
        }
        case LOGOUT_SUCCESS: {
            return initState
        }
        default:
            return state;
    }
}